import { render, staticRenderFns } from "./PortalSignaturePad.vue?vue&type=template&id=07875902&scoped=true&"
import script from "./PortalSignaturePad.vue?vue&type=script&lang=ts&"
export * from "./PortalSignaturePad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07875902",
  null
  
)

export default component.exports